import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import api from '../../../services/API';
import './styles.css';

const ModalPopup = ({ handleClose, ...props }) => {
  const [showModal, setShowModal] = useState(false);
  const [popup, setPopup] = useState(null);

  useEffect(() => {
    carregarPopup();
  }, []);

  const carregarPopup = async () => {
    try {
      const { data } = await api.get('/api/popups/ativo');

      if (data && data.popup) {
        setPopup(data.popup);
        setShowModal(true);
      }
    } catch (error) {
      console.error('Erro ao carregar popup:', error);
    }
  };

  const handleFechar = () => {
    setShowModal(false);
    if (handleClose) {
      handleClose();
    }
  };

  const handleResponder = () => {
    if (popup && popup.link) {
      window.open(popup.link, '_blank', 'noopener,noreferrer');
    }
    handleFechar();
  };

  const formatarCorpo = (corpo) => {
    if (!corpo) return '';
    // Divide o corpo em parágrafos baseado em quebras de linha
    const paragrafos = corpo.split('\n').filter(p => p.trim() !== '');
    return paragrafos;
  };

  if (!popup) {
    return null;
  }

  const paragrafos = formatarCorpo(popup.corpo);

  return (
    <Modal
      {...props}
      show={showModal}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      id="popup-modal"
      onHide={handleFechar}
      className="modal-popup"
    >
      <Modal.Body className="modal-popup-body">
        <button
          type="button"
          className="close-button"
          onClick={handleFechar}
          aria-label="Fechar"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <div className="modal-popup-icon">
          <div className="modal-popup-icon-circle">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z"
                fill="#4a76b9"
              />
              <path
                d="M12 5C12.5523 5 13 5.44772 13 6V10C13 10.5523 12.5523 11 12 11C11.4477 11 11 10.5523 11 10V6C11 5.44772 11.4477 5 12 5Z"
                fill="white"
              />
              <circle cx="12" cy="15" r="1.5" fill="white" />
            </svg>
          </div>
        </div>
        <h2 className="modal-popup-titulo">{popup.titulo}</h2>
        <div className="modal-popup-corpo">
          {paragrafos.map((paragrafo, index) => (
            <p key={index} className="modal-popup-paragrafo">
              {paragrafo}
            </p>
          ))}
        </div>
        <div className="modal-popup-botoes">
          <button
            type="button"
            className="btn-responder"
            onClick={handleResponder}
          >
            RESPONDER
          </button>
          <button
            type="button"
            className="btn-agora-nao"
            onClick={handleFechar}
          >
            Agora não
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ModalPopup;

